import { z } from 'zod';

export const CoreObjectTypeSchema = z.enum(['Location','CRM','CRMTopic','CRMComment','CRMAttachment','CRMMaterial','CRMTask','CRMWorkOrder','CRMMoniker','Department','Contact','Permit','Notification','CE','MapLayer','MapFeature']);

export type CoreObjectTypeType = `${z.infer<typeof CoreObjectTypeSchema>}`

export default CoreObjectTypeSchema;
